/**
 * Award Configuration
 * Centralized configuration for all award types
 * Per backend engineer's specification
 */

export const AWARD_CONFIG = {
  helpful: {
    type: "helpful",
    emoji: "🏆",
    label: "Helpful",
    color: "#FFD700",
    bgColor: "#FFD700",
    gradient: "linear-gradient(135deg, #FFD700, #FFA500)",
    description: "For insightful, helpful answers",
  },
  excellence: {
    type: "excellence",
    emoji: "🔬",
    label: "Excellence",
    color: "#3B82F6",
    bgColor: "#3B82F6",
    gradient: "linear-gradient(135deg, #3B82F6, #6366F1)",
    description: "For research/academic quality",
  },
  innovative: {
    type: "innovative",
    emoji: "💡",
    label: "Innovative",
    color: "#EAB308",
    bgColor: "#EAB308",
    gradient: "linear-gradient(135deg, #EAB308, #F59E0B)",
    description: "For novel, creative ideas",
  },
  educational: {
    type: "educational",
    emoji: "🎓",
    label: "Educational",
    color: "#8B5CF6",
    bgColor: "#8B5CF6",
    gradient: "linear-gradient(135deg, #8B5CF6, #A855F7)",
    description: "For teaching/educational content",
  },
  hot_take: {
    type: "hot_take",
    emoji: "🔥",
    label: "Hot Take",
    color: "#EF4444",
    bgColor: "#EF4444",
    gradient: "linear-gradient(135deg, #EF4444, #F97316)",
    description: "For controversial but valuable takes",
  },
};

// Array of award types for iteration
export const AWARD_TYPES = Object.keys(AWARD_CONFIG);

// Get award info by type
export const getAwardInfo = (type) => AWARD_CONFIG[type] || null;

// Format award count for display
export const formatAwardCount = (count) => {
  if (!count || count === 0) return "0";
  if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
  if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
  return count.toString();
};

export default AWARD_CONFIG;
